// 设备管理api
import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'MaintenancePlansProject/List',
        method: 'post',
        data
    })
}

export const detailApi = (data) => {
    return request({
        url: 'DeviceList/byData',
        method: 'post',
        data
    })
}

export const saveApi = (data) => {
    return request({
        url: 'MaintenancePlansProject/save',
        method: 'post',
        data
    })
}

export const planSaveApi = (data) => {
    return request({
        url: 'MaintenancePlans/save',
        method: 'post',
        data
    })
}